// extracted by mini-css-extract-plugin
export default {"label":"styles_label__AbwPs","formControl":"styles_formControl__sdWuc"};